import { PatchBodyPersonalDriverDataQueryType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyPersonalDriverData/patchBodyPersonalDriverDataQuery.type';
import { patchBodyPersonalDriverDataQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyPersonalDriverData/patchBodyPersonalDriverDataQueryFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const patchBodyPersonalDriverDataQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchBodyPersonalDriverDataQueryType
> => ({
  mutationKey: ['postDamagedVehicleCorrectiveImagesOptions'],
  mutationFn: (params: PatchBodyPersonalDriverDataQueryType) =>
    patchBodyPersonalDriverDataQueryFunction(params),
});
